export default function getLoginURL() {
  return '/insightweb/login'
}
